<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Orders</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item">Reports</li>
              <li class="breadcrumb-item active">Orders</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <div class="btn-toolbar pull-right">
              <button
                class="btn btn-info"
                type="button"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>

            <div class="card-tools">
              <button class="btn btn-info" @click="exportFile()">
                <i class="fas fa-download"></i> Export
              </button>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <filters
            v-if="showFilter"
            :filter="filter"
            @updateFilter="updateFilter"
          />
          <div class="card-body table-responsive p-0">
            <table class="table">
              <thead>
                <tr>
                  <th>Invoice#</th>
                  <th>TrxId</th>
                  <th>Username</th>
                  <!-- <th>Name</th> -->
                  <th>Courses</th>
                  <th>Subscription/Bundles</th>
                  <th>Payment method</th>
                  <th>Payer Number</th>
                  <th>Order price</th>
                  <th>Status</th>
                  <th>Is Availed?</th>
                  <th>Url</th>
                  <th>Platform</th>
                  <th>CreatedAt</th>
                </tr>
              </thead>
              <tbody class="list">
                <tr v-for="(order, index) in orders.data" :key="index">
                  <td>{{ order.invoice_no }}</td>
                  <td>{{ order.trx_id }}</td>
                  <td>{{ order.buyer ? order.buyer.username : "" }}</td>
                  <!-- <td>{{ order.buyer ? order.buyer.name : "" }}</td> -->
                  <td>
                    <span
                      class="badge bg-success"
                      v-for="(item, id) in order.courses"
                      :key="id"
                      >{{ item.course_title }} <br
                    /></span>
                  </td>
                  <td>
                    <span
                      class="badge bg-success"
                      v-for="(itemBundle, id) in order.bundles"
                      :key="id"
                      >{{ itemBundle.bundle_title }}</span
                    >
                  </td>
                  <td>{{ order.display_name }}</td>
                  <td>{{ order.payer_number }}</td>
                  <td>{{ order.order_price }}</td>
                  <td>
                    {{
                      Object.keys(orderStatus).find(
                        (key) =>
                          orderStatus[key] === parseInt(order.order_status)
                      )
                    }}
                  </td>
                  <td>{{ order.is_availed == 1 ? "Yes" : "No" }}</td>
                  <td>{{ order.url }}</td>
                  <td>{{ order.platform }}</td>
                  <td>
                    {{ order.created_at | moment }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              class="p-4"
              v-if="_.isEmpty(orders.data) && is_loading === false"
            >
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>

          <div class="card-footer">
            <vue-pagination
              :pagination="orders"
              v-if="orders.total > orders.per_page"
              @paginate="getOrders()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Filters from "./components/OrderFilter.vue";
import { LearningReportApi, CommonAPI } from "@/services/api";
import axios from "axios";

const fileDownload = require("js-file-download");

export default {
  name: "Orders",
  metaInfo: {
    title: "Orders | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
    Filters,
  },
  data: () => ({
    orders: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },

    showFilter: false,
    filter: {},
    is_loading: false,
    orderStatus: [],
  }),
  mounted: function () {
    this.getOrders();
  },
  methods: {
    getOrders() {
      this.filter = JSON.parse(JSON.stringify(this.$route.query));
      if (!_.isEmpty(this.filter)) this.showFilter = true;
      this.is_loading = true;
      let params = { ...this.filter, ...this.$route.query };
      LearningReportApi.orderList(params)
        .then((response) => {
          this.orders = response.data.orders;
          this.orderStatus = response.data.settings;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    updateFilter(val) {
      this.filter = val.filter;
      this.getOrders();
    },
    exportFile: function () {
      this.is_loading = true;
      axios
        .get("/reports/orders-export", {
          params: this.filter,
          responseType: "blob",
        })
        .then((response) => {
          console.log(response.data);
          fileDownload(response.data, "orders.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },
  },
};
</script>
